import { useIntl } from 'react-intl'
import messages from '../translations'
import DateFormat from '../../../helpers/DateFormat'

const BookingDetailsCardSummary = ({ order }) => {
  const intl = useIntl()
  const { shopKind, dateFrom, dateTo, duration, pax } = order
  return (
    <div className='info-table'>
      <div className='row'>
        <div className='cell'>
          <small>
            {intl.formatMessage(
              shopKind === 10 ? messages.start : messages.start
            )}
          </small>
          <DateFormat date={dateFrom} format='DD MMM YYYY' />
          <i className='cell-icon font-icons calendar-icon' />
        </div>
        <div className='cell'>
          <small>
            {intl.formatMessage(
              shopKind === 10 ? messages.end : messages.depart
            )}
          </small>
          <DateFormat date={dateTo} format='DD MMM YYYY' />
          <i className='cell-icon font-icons calendar-icon' />
        </div>
      </div>
      <div className='row'>
        <div className='cell'>
          <small>
            {intl.formatMessage(
              shopKind === 10 ? messages.duration : messages.nights
            )}
          </small>
          <span>
            {intl.formatMessage(messages.nightsPlural, { qty: duration })}
          </span>
          <i className='cell-icon font-icons icon-moon' />
        </div>
        <div className='cell'>
          <small>{intl.formatMessage(messages.guests)}</small>
          <span>{intl.formatMessage(messages.guestsPlural, { qty: pax })}</span>
          <i className='cell-icon font-icons peoples-icon' />
        </div>
      </div>
    </div>
  )
}

export default BookingDetailsCardSummary
